import { c as _c } from "react/compiler-runtime";
import { Badge } from '@common/components';
import { INTERACTIVE_SURFACE } from '@common/components/interaction';
import SvgChevronright from '@common/icon/SvgChevronright';
import { cn } from '@core/utils';
import type { ReactNode } from 'react';
import { CustomLink } from '@/app/_components/CustomLink';
import { Image } from '@/components/client';
import type { BenefitMenuCpc } from '../_utils/resolveBenefitMenuGroups';
import { resolveCpcBadgeLabel } from '../_utils/resolveCpcBadgeLabel';
interface BenefitMenuRowProps {
  imageUrl?: string;
  title: string;
  description?: string;
  isNew: boolean;
  isPopular: boolean;
  cpc?: BenefitMenuCpc | null;
  trailing?: ReactNode;
  //* url 항목은 링크 이동, placementKey 항목은 onSelect로 오퍼월을 연다. 둘 다 없으면 비활성.
  href?: string;
  onSelect?: () => void;
}
const ROW_CLASS_NAME = cn('group flex w-full items-center justify-between gap-12 rounded-small p-12', INTERACTIVE_SURFACE);
const RowChevron = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <SvgChevronright className="size-16 shrink-0 text-Gray-400 transition group-hover:translate-x-1 group-hover:text-Gray-700 group-focus-visible:translate-x-1 group-focus-visible:text-Gray-700" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export const BenefitMenuRow = t0 => {
  const $ = _c(36);
  const {
    imageUrl,
    title,
    description,
    isNew,
    isPopular,
    cpc,
    trailing,
    href,
    onSelect
  } = t0;
  let t1;
  if ($[0] !== imageUrl) {
    t1 = <Image src={imageUrl} alt="" width={40} height={40} sizes="40px" className="size-40 shrink-0 rounded-small object-cover" />;
    $[0] = imageUrl;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== title) {
    t2 = <p className="truncate font-600 text-Gray-900 typo-body4">{title}</p>;
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== isNew) {
    t3 = isNew ? <Badge dimensions="H20" className="bg-B-500 text-Gray-white">신규</Badge> : null;
    $[4] = isNew;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== isPopular) {
    t4 = isPopular ? <Badge className="bg-R-50 text-R-500">인기</Badge> : null;
    $[6] = isPopular;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t3 || $[10] !== t4) {
    t5 = <div className="flex max-w-full items-center gap-8">{t2}{t3}{t4}</div>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== description) {
    t6 = description ? <p className="break-keep font-600 text-Gray-600 typo-caption1">{description}</p> : null;
    $[12] = description;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t5 || $[15] !== t6) {
    t7 = <div className="flex min-w-0 flex-col items-start">{t5}{t6}</div>;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t1 || $[18] !== t7) {
    t8 = <div className="flex min-w-0 flex-1 items-center gap-16">{t1}{t7}</div>;
    $[17] = t1;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  const info = t8;
  let t9;
  if ($[20] !== cpc) {
    t9 = cpc ? <Badge className={cpc.isParticipated ? "bg-Gray-50 text-Gray-600" : "bg-B-50 text-B-500"}>{resolveCpcBadgeLabel(cpc)}</Badge> : null;
    $[20] = cpc;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <RowChevron />;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t9 || $[24] !== trailing) {
    t11 = <div className="flex shrink-0 items-center gap-8 whitespace-nowrap">{trailing}{t9}{t10}</div>;
    $[23] = t9;
    $[24] = trailing;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  const trailingContent = t11;
  if (href) {
    let t12;
    if ($[26] !== href || $[27] !== info || $[28] !== trailingContent) {
      t12 = <CustomLink href={href} className={ROW_CLASS_NAME}>{info}{trailingContent}</CustomLink>;
      $[26] = href;
      $[27] = info;
      $[28] = trailingContent;
      $[29] = t12;
    } else {
      t12 = $[29];
    }
    return t12;
  }
  if (onSelect) {
    let t12;
    if ($[30] !== info || $[31] !== onSelect || $[32] !== trailingContent) {
      t12 = <button onClick={onSelect} className={ROW_CLASS_NAME}>{info}{trailingContent}</button>;
      $[30] = info;
      $[31] = onSelect;
      $[32] = trailingContent;
      $[33] = t12;
    } else {
      t12 = $[33];
    }
    return t12;
  }
  let t12;
  if ($[34] !== info) {
    t12 = <div aria-disabled="true" className="flex items-center justify-between rounded-xsmall py-12 opacity-50">{info}</div>;
    $[34] = info;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  return t12;
};